var site = site || {};
site.Utilities = (function () {
	// Functions

	var initSearchDestinations = function () {

		const urlParams = new URLSearchParams(window.location.search);
		const searchDestItems = document.querySelectorAll('.js-search-destinations');
		searchDestItems.forEach(searchDest => {

			if(urlParams.has('Region')) {
				const region = urlParams.get('Region');
				document.getElementById("filterRegion").value = region;
			}
			if(urlParams.has('CapacityVal')) {
				const capacity = urlParams.get('CapacityVal');
				document.getElementById("filterCapacity").value = capacity;
			}
			if(urlParams.has('GuestRoomsVal')) {
				const rooms = urlParams.get('GuestRoomsVal');
				document.getElementById("filterGuestRooms").value = rooms;
			}
			if (urlParams.has('VenueTypesVal')) {
				const venues = urlParams.get('VenueTypesVal');
				var venueArr = venues != null ? venues.split(',') : [];
				$('.js-select2-venue').val(venueArr);
			}

			searchDest.addEventListener('click', function(e) {

				var venueTypesValueArr = [],
					venueTypesNameArr = [];
				$('.js-select2-venue').find(':selected').each(function() {
					var curValue = $(this).val(),
						curText = $(this).text(),
						curTextTrim = curText != null && curText != undefined ? curText.trim() : '';
					venueTypesValueArr.push(curValue);
					venueTypesNameArr.push(curTextTrim);
				});
				var venueTypesValue = venueTypesValueArr.join(','),
					venueTypesName = venueTypesNameArr.join(',');


				const region = document.getElementById("filterRegion"),
					regionValue = region.value,
					guestRooms = document.getElementById("filterGuestRooms"),
					guestRoomsValue = guestRooms ? guestRooms.value : null,
					guestRoomsName = guestRooms ? guestRooms.options[guestRooms.selectedIndex].text : '',
					capacity = document.getElementById("filterCapacity"),
					capacityValue = capacity ? capacity.value : null,
					capacityName = capacity ? capacity.options[capacity.selectedIndex].text : '';
					

				var baseUrl = '/destinations',
					newParams = new URLSearchParams();

				if(regionValue) newParams.append('Region', String(regionValue));
				if(guestRoomsValue){
					newParams.append('GuestRoomsVal', String(guestRoomsValue));
					newParams.append('GuestRoomsName', String(guestRoomsName));
				}
				if(capacityValue){
					newParams.append('CapacityVal', String(capacityValue));
					newParams.append('CapacityName', String(capacityName));
				}
				if (venueTypesValue) {
					newParams.append('VenueTypesVal', String(venueTypesValue));
					newParams.append('VenueTypesName', String(venueTypesName));
				}

				const searchUrl = baseUrl + '?' + newParams.toString() + '&#mapDestinations';
				window.location.href = searchUrl;
			});
		});


		$('.js-select2-venue').select2({
			placeholder: "Select Venue Type",
			allowClear: true
		});
	}


	/**
	 * Toggle Nav Search visibility
	*/
	//var toggleNavSearch = function () {
	//	const toggleSearchItems = document.querySelectorAll('.js-toggle-search');
	//	const offcanvasSearch = document.getElementById('js-offcanvas-search');
	//	const closeSearch = document.getElementById('js-close-search');

	//	toggleSearchItems.forEach(searchItem => {
	//		searchItem.addEventListener('click', function(e) {
	//			searchItem.classList.toggle('animate');
	//			offcanvasSearch.classList.toggle('active');
	//		});
	//	});

	//	closeSearch.addEventListener('click', function(e) {
	//		toggleSearchItems.forEach(searchItem => {
	//			searchItem.classList.remove('animate');
	//		});
	//		offcanvasSearch.classList.remove('active');
	//	});

	//	document.addEventListener('click', function(e){
	//		if (!e.target.matches('.js-toggle-search, .js-toggle-search *, #js-offcanvas-search, #js-offcanvas-search *')) {
	//			toggleSearchItems.forEach(searchItem => {
	//				searchItem.classList.remove('animate');
	//			});
	//			offcanvasSearch.classList.remove('active');
	//		}
	//	})
	//}


	/**
	 * Toggle Off Canvas (Mobile) Nav Search visibility
	*/
	var toggleOffCanvasNav = function () {
		const toggleNav = document.getElementById('js-toggle-nav');
		const offcanvasNav = document.getElementById('js-offcanvas-nav');
		const offcanvasNavShadow = document.createElement("div");
		document.body.appendChild(offcanvasNavShadow);
		offcanvasNavShadow.classList.add('offcanvas-nav-shadow');
		offcanvasNavShadow.setAttribute("id", "js-offcanvas-nav-shadow")

		if(offcanvasNav != null) {
			toggleNav.addEventListener('click', function(e) {
				toggleNav.classList.toggle('animate');
				offcanvasNav.classList.toggle('active');
				offcanvasNavShadow.classList.toggle('active');
			});
	
			document.addEventListener('click', function(e){
				if (!e.target.matches('#js-toggle-nav, #js-toggle-nav *, #js-offcanvas-nav, #js-offcanvas-nav *, #js-offcanvas-search, #js-offcanvas-search *')) {
					toggleNav.classList.remove('animate');
					offcanvasNav.classList.remove('active');
					offcanvasNavShadow.classList.remove('active');
				}
			})
		}
	}


	/**
	 * Close nav menus
	*/
	var closeNavMenus = function() {
		const toggleNav = document.getElementById('js-toggle-nav');
		const offcanvasNav = document.getElementById('js-offcanvas-nav');
		const offcanvasNavShadow = document.getElementById('js-offcanvas-nav-shadow');
		const offcanvasSearch = document.getElementById('js-offcanvas-search');
		//const toggleSearchItems = document.querySelectorAll('.js-toggle-search');

		toggleNav.classList.remove('animate');
		offcanvasNav.classList.remove('active');
		offcanvasNavShadow.classList.remove('active');
		if(offcanvasSearch) offcanvasSearch.classList.remove('active');

		//closeAllNavSubmenus();
	}


	// var closeAllNavSubmenus = function () {
	// 	const subMenuBodies = document.querySelectorAll('.js-nav-submenu-body');
	// 	subMenuBodies.forEach(body => {
	// 		body.classList.add('hidden');
	// 	});
	// }

	


	/**
	 * Check Footer - if window height is taller than body, move footer to absolute bottom
	*/
	var checkFooter = function () {
		var winHeight = window.innerHeight,
			header = document.getElementsByTagName('header'),
			main = document.getElementById('main'),
			footer = document.getElementById('footer'),
			headerHeight = header ? header[0].offsetHeight : 0,
			mainHeight = main ? main.offsetHeight : 0,
			footerHeight = footer ? footer.offsetHeight : 0,
			bodyHeight = headerHeight + mainHeight + footerHeight;

		if(header && main && footer && winHeight > bodyHeight) {
			footer.classList.add('absolute-bottom');
		} else {
			footer.classList.remove('absolute-bottom');
		}

	}


	var eventTrackingForGTM = function($) {
        $(document).on('click', '.js-nav-link', function(){
            dataLayer.push({'event': 'sidebarNav'});
        })
    }



	// Return
	return {
		checkFooter: checkFooter,
		closeNavMenus: closeNavMenus,
		eventTrackingForGTM: eventTrackingForGTM,
		initSearchDestinations: initSearchDestinations,
		//toggleNavSearch : toggleNavSearch,
		toggleOffCanvasNav : toggleOffCanvasNav
	};
}());